{
  "name": "@ns/public-ledger-auto-payments-limit-reached",
  "version": "1.2.0",
  "description": "A monthly automatic payments limit is reached (#25 phase 4): LIMIT CARD (succeeded charges less refunds) or OPERATING (operating top-ups), for MONTH (YYYY-MM, UK time). Claimable by the company's public ledger signatories; one per company, limit and month. Server outcomes only: close-for-month (public-ledger/autopay/card-action close-for-month), month-ended (the sweep, once the month is over). raise (card-action raise, #25 phase 6) starts Change automatic payments amounts as the workflow's child; the card closes when the child ends.",
  "inputs": {},
  "outcomes": {
    "close-for-month": {
      "serverOnly": true
    },
    "month-ended": {
      "serverOnly": true
    },
    "raise": {
      "serverOnly": true
    },
    "stopped": {
      "serverOnly": true
    }
  }
}
